// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3nl4T","title":"AfterBackImages_title__1Cexs","images":"AfterBackImages_images__2vuJe"};